import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getCompilations } from '../../components/apis/music-api';
import { AuthenticationContext } from '../../components/authentication/AuthenticationContext';
import callApi from '../../components/call-api/call-api';

const CompilationDirectories = () => {
  const { getAccessToken } = useContext(AuthenticationContext);
  const [ compilations, setCompilations ] = useState<{ directory: string, count: number }[]>();
    
  useEffect(() => {
    callApi<{ directory: string, count: number }[]>(getCompilations(getAccessToken()), setCompilations);
  }, [getAccessToken]);

  return (
    <>
      <h2>Compilation Directories</h2>
      <p>{compilations?.length} directories</p>
      {compilations?.map((compilation: { directory: string, count: number }, index: number) =>
        <Box sx={{ p: '6px' }} key={`$compilation-${index}`}>
          <Link to={`/compilations/${compilation.directory}`}>{compilation.directory}</Link> ({compilation.count})
        </Box>
      )}
    </>
  )
}

export default CompilationDirectories;